import React,{useState} from "react";
import { useTable, useFilters, useGlobalFilter, useSortBy,useExpanded } from "react-table";
import { Icon } from "@fluentui/react";
import { GlobalFilter, DefaultFilterForColumn } from "./Filter";
import { t } from "i18next";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

import './Table.css';

export default function Table(props) {
    let columns = props.columns;
    let data = props.data;
    let customSortFunction = props.handleClick;
    
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    state,
    visibleColumns,
    prepareRow,
    setGlobalFilter,
    preGlobalFilteredRows,
    state: { sortBy,expanded },
    getTrProps
    
  } = useTable(
    {
      columns,
       data,
      defaultColumn: { Filter: DefaultFilterForColumn },
      manualPagination: true,
      getSubRows: props.getSubRows,
      //manualSortBy: true
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    useExpanded
  );

 

  return (
    <div>
    {props.tableName==null||props.tableName==undefined?<>
      <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            style={{marginBottom: 20}}
      />
    </>
    
    :props.showGlobalFilter?
        <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>{props.tableName}</div>
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
              style={{marginBottom: 20}}
            />
        </div>
        :<></>}

    <table {...getTableProps()} style={{width:"100vw"}}>
      <thead className={`${!isMobile ? "table-thead" : ""}`}>
        {headerGroups.map((headerGroup,i) => {
          // {customSortFunction?props.handleClick(sortBy):null}
            const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
           return (<tr key={key} {...restHeaderGroupProps}>
             {headerGroup.headers.map((column,j) => {
              const { key, ...restColumn } = column.getHeaderProps();
              return (<th key={key} {...column.getHeaderProps({
                className: column.className,
              })} 
              >
                {column.render("Header")}{" "}
                
                {column.sorting?column.isSorted
                  ? column.isSortedDesc
                    ? 
                    <Icon key={j} {...column.getHeaderProps(column.getSortByToggleProps())} iconName="SortUp" className="ms-fontSize-12"></Icon>
                    :
                    <Icon key={j} {...column.getHeaderProps(column.getSortByToggleProps())} iconName="SortDown" className="ms-fontSize-12"></Icon>                    
                    : <> 
                    <Icon key={j} {...column.getHeaderProps(column.getSortByToggleProps())} iconName="Sort" className="ms-fontSize-12"></Icon>
                    </>:<></>
                }
             
              </th>)
              
            })}
           </tr>)
})}
      </thead>
     <tbody {...getTableBodyProps()}
     className={`${
         !isMobile ? "table-tbody modal-scroll" : "table-tbody modal-scroll"
       }`}
     >
        {rows.length > 0 && rows.map((row, i) => {
          prepareRow(row);
          return (
           
            <tr key={i} {...row.getRowProps({style:row.depth == 1?{background:'#80808033'}:row.depth==2?{background:'#80808096'}:null})} className={`${!isMobile ? "table-tr" : ""}`} >
              {row.cells.map((cell,i) => {
                 const {key, ...restCellProps} = cell.getCellProps();
                return <td  key={key} {...cell.getCellProps({className:cell.column.classChildName,style:cell.column.rowStyle})}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        return <></>
        })
    }
      </tbody>
    </table>
    {rows.length==0 &&<p style={{textAlign:'center',paddingTop:'10px'}}>{t("table.no-result-found")}</p>}
    </div>
    
  );
}